import type {
  HighFrequency_AddOnConfig,
  HighFrequency_AddOnRestriction,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type RestrictionPayload = { selectedNumbers: number[] }

type AddOnRestrictionHandler = (
  restriction: HighFrequency_AddOnRestriction,
  payload: RestrictionPayload,
) => boolean | undefined

const HANDLERS: AddOnRestrictionHandler[] = [
  (restriction, { selectedNumbers }) => {
    if (!isHighFrequencyAddOnExcludeSelectedNumbers(restriction)) return

    return restriction.selected.includes(selectedNumbers.length)
  },
]

const isAddOnDisabled = (
  restriction: HighFrequency_AddOnRestriction,
  payload: RestrictionPayload,
) => HANDLERS.some((handler) => handler(restriction, payload) === true)

type EligibilityAddOn = Pick<HighFrequency_AddOnConfig, 'name' | 'restrictions'>

export const disabledAddOns = (addOns: EligibilityAddOn[], selectedNumbers: number[]): string[] =>
  addOns
    .filter((addOn) =>
      addOn.restrictions.some((restriction) => isAddOnDisabled(restriction, { selectedNumbers })),
    )
    .map((addOn) => addOn.name)
